/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com


 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
// import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function CheticampCandidatesInformation() {
  return (
    <MKBox component="section" py={12}>
      
<style>
        {`
          table {
            border-collapse: collapse;
            width: 100%;
          }

          th, td {
            padding: 10px 14px;
            text-align: center;
            border: 1px solid #666;
          }

          th {
            background-color: #f5f5f5;
          }
        `}
      </style>

      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <Box id="candidates" mb={8}>
          <Typography variant="h4" mb={2}>Candidate Nomination Deadline</Typography>
          <Typography>
            <b>Candidate Nominations Close</b> - Wednesday, June 3, 2026, at 2pm. <br/>
            Chief Electoral Officer (CEO) Dorothy Rice has issued a directive that the $200 candidate nomination fee is not required for the Chéticamp-Margarees-Pleasant Bay by-election. 
          <br/><br/>
          </Typography>
          <Typography variant="h4" mb={2}>Who is Running in the By-election?</Typography>
          <Typography variant="h4" mb={2}>Registered Candidates</Typography>      
          <Typography>
            Individuals who intend to run as a candidate may register with Elections Nova Scotia prior to a writ of election being issued. This allows the candidate to accept contributions and incur expenses. Once the writ of election is issued, potential candidates must complete their official nomination form. <br/>
            The following candidate(s) were registered with Elections Nova Scotia prior to the Chéticamp-Margarees-Pleasant Bay by-election but have not yet not filed their official nomination forms:<br/>
            <br/>
            <div >
              <table border="1" cellPadding="1" cellSpacing="1" >
                <thead>
                  <tr>
                    <th>Candidate Name</th>
                    <th>Registered Political Party</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Claude A. Bourgeois</td>
                    <td>PC</td>
                  </tr>
                  <tr>
                    <td>Denis Cormier</td>
                    <td>Liberal</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
          </Typography>
          <Typography variant="h4" mb={2}>Nominated Candidates</Typography>      
          <Typography>
            Now that the Chéticamp-Margarees-Pleasant Bay by-election is underway, candidates must complete official nomination forms and have them accepted by the Returning Officer to have their name added to the ballot. The nomination process includes the following:
            <ul style={{ paddingLeft: "40px" }}>
            <li>Filing a completed Candidate nomination form (form 105) with the returning officer in the electoral district in which the candidate wishes to run.</li>
            <li>Providing the name and contact information of their appointed official agent.</li>
            <li>Providing the name and contact information of their appointed auditor, who must be a public accountant licensed by CPANS to audit.</li>
            <li>Providing nomination papers signed by at least five electors, from the electoral district in which the candidate wishes to run, who are eligible to vote.</li>
            <li>Filing an endorsement letter from the Party leader if the candidate is running for a registered political party</li>
          </ul>
          <br/>
          The deadline for candidate nominations for the Chéticamp-Margarees-Pleasant Bay by-election is Wednesday, June 3, 2026 at 2 pm. <br/>
          Elections Nova Scotia publishes the names of nominated candidates and the names of the official agent for their campaign.<br/>
          <i>(Candidate and official agent names will be added as nominations are received)</i><br/>
          <br/>
          The following candidate(s) are nominated for the Chéticamp-Margarees-Pleasant Bay by-election: <br/>

            <div >
              <table border="1" cellPadding="4" cellSpacing="1" >
                <thead>
                  <tr>
                    <th>Candidate Name</th>
                    <th>Registered Political Party</th>
                    <th>Official Agent Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>-</th>
                    <th>-</th>
                    <th>-</th>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
          </Typography>
          <Typography variant="h4" mb={2}>Candidate and Party Spending Limits for the Chéticamp-Margarees-Pleasant Bay by-election</Typography>      
          <Typography>
            The following amounts are determined according to the Elections Act (updated to include CPI adjustments):
            <br/><br/>
            <b>Initial Number of Electors: 3,923 (as of May 24, 2026)</b>
            <br/>
            <b>Candidate Spending Limit*: $31,705</b>
            <br/>
            <b>Candidate Reimbursement Limit: $7,926.25</b>
            <br/>
            <b>Registered Party Spending Limit: $8,086.35</b>
            <br/>
            <b>Third Party Spending Limit: $2,825.81</b>
            <br/><br/>
          <i>*Candidate spending limit may be adjusted based on the number of electors on the Final List of Electors. The final list will be completed after election day.</i> <br/>
          </Typography>
        </Box>              
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CheticampCandidatesInformation;
